import {useEffect, useState} from 'react';
import {getResearchReportDetail} from '../../../services/researchReportService';
import type {ResearchReportDetail} from '../../../types/researchReport';

export const formatReportTime = (ts?: number): string =>
    null == ts ? '--' : new Date(ts).toLocaleString('zh-CN', {hour12: false});

/**
 * 研报详情加载（执行记录弹窗 / 结束卡片抽屉共用）：
 * 仅在打开且 reportId 有效时拉取；空正文与加载失败都给出提示文案，不静默。
 */
export const useResearchReportDetail = (open: boolean, reportId: number | null) => {
    const [detail, setDetail] = useState<ResearchReportDetail | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!open || null == reportId) {
            setDetail(null);
            setError('');
            return;
        }
        let alive = true;
        setLoading(true);
        setError('');
        getResearchReportDetail(reportId)
            .then(data => {
                if (!alive) return;
                if (null == data?.content) {
                    setDetail(null);
                    setError('该研报暂无正文内容（可能生成失败或已删除）');
                    return;
                }
                setDetail(data);
            })
            .catch((e: any) => {
                if (!alive) return;
                setDetail(null);
                setError(e?.message ?? '研报加载失败');
            })
            .finally(() => {
                if (alive) setLoading(false);
            });
        return () => {
            alive = false;
        };
    }, [open, reportId]);

    return {detail, loading, error};
};
